import { Moon, Sun } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useSettingsStore } from '@/stores/settingsStore';

export function ThemeToggle() {
  const themeMode = useSettingsStore(state => state.themeMode);
  const onToggleMode = useSettingsStore(state => state.onToggleMode);
  const isDark = themeMode === 'dark';

  return (
    <Button
      variant="ghost"
      size="icon"
      className="h-9 w-9 text-foreground"
      onClick={onToggleMode}
      aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
    >
      {isDark ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
    </Button>
  );
}
